// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3955":"css/app.7089","8346":"css/admin-app.7089"}[chunkId] + ".css";
};